/// <amd-module name="VSS/Features/Directory/DirectoryContentView" />
export * from "./components/DirectoryContentView/index";
